<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Feriado
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <label><span class="required">*</span> Nome</label>
            <input
              v-model="holiday.name"
              type="text"
              class="form-control"
            >
          </div>
          <div class="col-md-6">
            <label><span class="required">*</span> Empresa</label>
            <select
              v-model="holiday.company_id"
              class="form-control"
            >
              <option
                v-for="company in companies"
                :key="company.id"
                :value="company.id"
              >
                {{ company.company_name }}
              </option>
            </select>
          </div>
          <div class="col-md-6 mt-1">
            <label><span class="required">*</span> Fixo</label>
            <select
              v-model="holiday.fixed"
              class="form-control"
            >
              <option value="0">
                Não
              </option>
              <option value="1">
                Sim
              </option>
            </select>
          </div>
          <div
            v-show="holiday.fixed == '1'"
            class="col-md-6 mt-1"
          >
            <label><span class="required">*</span> Dia/Mẽs</label>
            <input
              v-model="holiday.dayAndMonth"
              v-mask="'##/##'"
              type="text"
              class="form-control"
            >
          </div>
          <div
            v-show="holiday.fixed == '0'"
            class="col-md-6 mt-1"
          >
            <label><span class="required">*</span> Data</label>
            <input
              v-model="holiday.specific_date"
              type="date"
              class="form-control"
            >
          </div>
        </div>
        <div class="block text-right mb-1">
          <router-link
            to="/holidays"
            class="btn btn-back"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-add ml-1"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      holiday: {
        name: '',
        fixed: '0',
        dayAndMonth: '',
        specific_date: '',
      },
      companies: [],
    }
  },
  mounted() {
    const self = this

    const { id } = self.$route.params
    if (id) {
      self.getHoliday(id)
    }

    self.getCompanies()
  },
  methods: {
    save() {
      const self = this

      if (self.holiday.id) return self.edit()

      const api = `${this.$store.state.api}holidays`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message('Sucesso', 'Feriado cadastrado com sucesso', 'success')
          this.$router.push('/holidays')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    edit() {
      const self = this
      const api = `${self.$store.state.api}holidays/${self.holiday.id}`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message('Sucesso', 'Feriado editado com sucesso', 'success')
          this.$router.push('/holidays')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    makeFormData() {
      const self = this

      const fd = new FormData()

      // if(!self.manualCheck.time || self.manualCheck.time.length < 8){
      //     self.$message('Erro', 'Preencha horas válidas', 'error');
      //     return false;
      // }

      fd.append('name', self.holiday.name)
      fd.append('fixed', self.holiday.fixed)
      fd.append('company_id', self.holiday.company_id)

      if (self.holiday.fixed == '1') {
        const dayAndMonth = self.holiday.dayAndMonth.split('/')
        if (
          dayAndMonth.length == 2
          && dayAndMonth[0].length == 2
          && dayAndMonth[1].length == 2
        ) {
          fd.append('month', dayAndMonth[1])
          fd.append('day', dayAndMonth[0])
        } else {
          self.$message('Erro', 'Data/Mẽs inválido', 'error')
          return false
        }
      } else {
        fd.append('specific_date', self.holiday.specific_date)
      }

      if (self.holiday.id) {
        fd.append('id', self.holiday.id)
        fd.append('_method', 'PUT')
      }

      return fd
    },
    getHoliday(id) {
      const self = this
      const api = `${self.$store.state.api}holidays/${id}`

      axios
        .get(api)
        .then(response => {
          const holiday = response.data.data[0]
          if (holiday.fixed == '1') {
            holiday.dayAndMonth = `${holiday.day}/${holiday.month}`
          }
          self.holiday = holiday
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    getCompanies() {
      const self = this
      const api = `${self.$store.state.api}companies`

      axios
        .get(api)
        .then(response => {
          console.log(response)
          self.usersLoading = true
          self.companies = response.data.data
        })
        .catch(error => {
          // vm.$toast.error(error.response.data.message);
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
